import { Component, HostListener, Input, OnInit } from "@angular/core";

@Component({
  selector: "tooltip",
  templateUrl: "./tooltip.component.html",
  styleUrls: ["./tooltip.component.css"]
})
export class TooltipComponent implements OnInit  {
  @Input() text: string;
  @Input("hide-if-empty") hideIfEmpty: boolean;
  shown = false;

  @HostListener("mouseenter")
  showTooltip() {
    this.shown = true;
  }

  @HostListener("mouseleave")
  hideTooltip() {
    this.shown = false;
  }
  
  canShow = false;

  ngOnInit() {
      this.canShow = this.text && this.text.length !== 0;
  }
}
